import { functions } from '../../modules/functions'
import { TextSpanWrap } from '../../modules/textSpanWrap';

export module MainVisualModule {
  export class Service {
    constructor(language?: string) {
      document.addEventListener('readCompleteAction', () => {
        Service.action();
      });
    }

    public static action() {
      let $windowWidth = functions.getWindowWidth();
      let $targets = document.querySelectorAll('.mainVisual__headerCaptionText');
      if ($targets) {
        $targets.forEach($target => {
          TextSpanWrap.run($target);
        });
      }
    }
  }
}